/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

// import { setCookie, getCookie } from "./components/cookies";
import Accessibility from "./components/Accessibility";
import Links from "./components/Links";
// import Sliders from "./components/Sliders";

document.addEventListener("DOMContentLoaded", () => {

    Links();
    Accessibility();

    const backButton = document.querySelector('.footer__bottom-back-link');
    const burgerWrapper = document.querySelector(".burger-menu");
    const burgerClose = document.querySelector(".burger-menu__close");
    const burgerLines = document.querySelector(".burger-js");
    const header = document.querySelector(".header");

    if (burgerLines) {
        burgerLines.addEventListener("click", function () {
            if (burgerWrapper) {
                burgerWrapper.classList.add("active");
            }
        });
    }

    if (burgerClose) {
        burgerClose.addEventListener("click", function () {
            if (burgerWrapper) {
                burgerWrapper.classList.remove("active");
            }
        });
    }

    if (burgerWrapper) {
        burgerWrapper.addEventListener("click", function (e) {
            if (e.target === burgerWrapper) {
                burgerWrapper.classList.remove("active");
            }
        });
    }

    if (header) {
        const toggleFixed = () => {
            header.classList.toggle("fixed", window.scrollY > 0);
        };

        toggleFixed();
        window.addEventListener("scroll", toggleFixed);
    }
    
    if(backButton) {
        backButton.addEventListener('click', (e) => {
            e.preventDefault();

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});
